<template>
  <div class="bg-white px-6 py-4 my-4 relative overflow-hidden">
    <form class="h-full" @submit.prevent="store" v-if="formStage === 1">
      <div class="lg:flex flex-col w-full relative">
        <div
          class="h-full w-full bg-white bg-opacity-75 absolute"
          v-if="showFormOverlay"
        ></div>
        <div class="p-2 lg:mx-4 flex justify-between w-full">
          <div>
            <h2 class="text-2xl font-bold mb-5">
              {{ form.edit ? "Edit Farm" : " Add new Farm" }}
            </h2>
          </div>
        </div>
        <div class="p-2 lg:mx-4 w-full md:w-1/2">
          <label class="block text-sm font-medium text-gray-700" for="name">
            Farm Name
          </label>
          <input
            class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
            id="name"
            type="text"
            autocomplete="name"
            v-model="form.name"
            required
          />
          <div class="text-red-600" v-if="errors && errors.name">
            {{ errors.name[0] }}
          </div>
        </div>
        <div class="p-2 lg:mx-4">
          <button
            type="button"
            @click="addFarmPoint('farm-location')"
            v-if="form.action == 'update-farm' || form.action == 'create-farm'"
            class="btn-primary"
          >
            Set Location
          </button>
        </div>
        <div class="p-2 lg:mx-4">
          <div class="flex gap-x-5">
            <button type="button" @click="closeCreate" class="btn-secondary">
              Cancel
            </button>
            <button type="submit" @click="saveFarm" class="btn-primary">
              Save Farm
            </button>
          </div></div>
      </div>
    </form>

    <!-- The add field form -->

    <div v-if="formStage === 2">
      <div class="flex flex-no-wrap justify-between">
        <div class="p-4 flex gap-4">
          <h2 class="font-bold">{{ farm.farm_name }}</h2>
          <a href="#" @click.prevent="EditFarm"><EditIcon /></a>
          <LocationMark
            :colour="farm.farm_location_set ? '#1E660B' : '#FE2121'"
          />
        </div>
        <div class="flex">
          <a href="#" class="text-red-600" @click.prevent="backToFarms()">
            ← Farms</a
          >
        </div>
      </div>
      <div class="w-full flex flex-row justify-between mt-2">
        <div class="flex gap-7">
          <button
            type="submit"
            @click="tab = 'parcels'"
            :class="
              tab === 'parcels' ? 'btn-secondary' : 'btn-secondary-outline'
            "
          >
            Parcels
          </button>

          <button
            type="submit"
            @click="tab = 'zones'"
            :class="tab === 'zones' ? 'btn-secondary' : 'btn-secondary-outline'"
          >
            Sample Zones
          </button>

          <button
            v-if="showSamplePath"
            type="submit"
            @click="tab = 'sample_paths'"
            class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-2xl text-white bg-[#1E660B] hover:bg-[#1E660B] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            :class="
              tab === 'sample_paths'
                ? '!bg-white !text-[#1E660B] !border-[#1E660B]'
                : ''
            "
          >
            Tasks
          </button>
        </div>
      </div>
      <div class="mt-8">
        <div v-if="tab === 'parcels'">
          <div class="flex justify-end">
            <button
              type="submit"
              @click="createNew('parcels')"
              :disabled="loading"
              class="inline-flex mb-3 justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-full text-white bg-[#1E660B] hover:bg-[#1E660B] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              New parcel +
            </button>
          </div>
          <table
            class="table-auto min-w-full divide-y divide-gray-400 border-b border-gray-400 border-collapse rounded-lg"
          >
            <thead>
              <tr class="bg-gray-200 font-bold text-sm text-gray-900">
                <th scope="col" class="px-1 py-2.5 text-left">Parcel Name</th>
                <th scope="col" class="px-1 py-2.5 text-left">Parcel No</th>
                <th scope="col" class="px-1 py-2.5 text-left">NMP Plot ID</th>
                <th scope="col" class="px-1 py-2.5 text-left">Crop</th>
                <th scope="col" class="px-1 py-2.5 text-left">Soil Type</th>
                <th scope="col" class="px-1 py-2.5 text-left"></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(parcel, index) in parcels"
                :key="index"
                class="odd:bg-white even:bg-slate-100 text-gray-900 text-sm"
              >
                <td class="px-1 py-2.5 cursor-pointer">
                  {{ parcel.name }}
                </td>
                <td class="px-1 py-2.5">
                  {{ parcel.field_no }}<span v-if="parcel.field_no_suffix">{{ parcel.field_no_suffix }}</span>
                </td>
                <td class="px-1 py-2.5 text-gray-600">
                  {{ parcel.nmp_plot_id || '-' }}
                </td>
                <td class="px-1 py-2.5 cursor-pointer">
                  {{ parcel.crop }}
                </td>
                <td class="px-1 py-2.5">
                  {{ parcel.soil_type }}
                </td>
                <td class="px-1 py-2.5">
                  <a href="#" @click="Edit(parcel)">Edit </a>
                  |
                  <a href="#" @click="Delete(parcel)">Delete</a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div v-if="tab === 'zones'">
          <div class="flex justify-end"></div>
          <table
            class="table-auto min-w-full divide-y divide-gray-400 border-b border-gray-400 border-collapse rounded-lg"
          >
            <thead>
              <tr class="bg-gray-200 font-bold text-sm text-gray-900">
                <th scope="col" class="px-1 py-2.5 text-left">Zone No</th>
                <th scope="col" class="px-1 py-2.5 text-left">Crop</th>
                <th scope="col" class="px-1 py-2.5 text-left">Soil Type</th>
                <th scope="col" class="px-1 py-2.5 text-left"></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(zone, index) in zones"
                :key="index"
                class="odd:bg-white even:bg-slate-100 text-gray-900 text-sm"
              >
                <td class="px-1 py-2.5 cursor-pointer">
                  {{ zone.field_no }}
                </td>
                <td class="px-1 py-2.5">
                  {{ zone.crop }}
                </td>

                <td class="px-1 py-2.5">
                  {{ zone.soil_type }}
                </td>

                <td class="px-1 py-2.5">
                  <a
                    href="#"
                    @click="Delete(zone)"
                    v-if="$page.props.auth.user.role == 'admin'"
                    >Delete</a
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div v-if="tab === 'sample_paths'">
          <table
            class="table-auto min-w-full divide-y divide-gray-400 border-b border-gray-400 border-collapse rounded-lg"
          >
            <thead>
              <tr class="bg-gray-200 font-bold text-sm text-gray-900">
                <th scope="col" class="px-1 py-2.5 text-left">Task ID</th>
                <th scope="col" class="px-1 py-2.5 text-left">Soil Sampler</th>
                <th scope="col" class="px-1 py-2.5 text-left">Date</th>
                <th scope="col" class="px-1 py-2.5 text-left">Actions</th>
                <th scope="col" class="px-1 py-2.5 text-left"></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(sample_path, index) in sample_paths"
                :key="index"
                class="odd:bg-white even:bg-slate-100 text-gray-900 text-sm"
              >
                <td class="px-1 py-2.5 cursor-pointer">
                  {{ sample_path.task_id }}
                </td>
                <td class="px-1 py-2.5">
                  {{ sample_path.soil_sampler }}
                </td>

                <td class="px-1 py-2.5">
                  {{ sample_path.date }}
                </td>

                <td class="px-1 py-2.5">
                  <div class="flex items-center gap-2">
                    <button
                      @click="locateSamplePath(sample_path)"
                      class="inline-flex items-center justify-center w-8 h-8 rounded-full border border-gray-300 bg-white hover:bg-gray-50 shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      :title="sample_path.sample_paths && sample_path.sample_paths.length > 0 ? 'Locate sample path on map' : 'No location data available'"
                      :disabled="!sample_path.sample_paths || sample_path.sample_paths.length === 0"
                      :class="{
                        'opacity-50 cursor-not-allowed': !sample_path.sample_paths || sample_path.sample_paths.length === 0,
                        'hover:bg-gray-50': sample_path.sample_paths && sample_path.sample_paths.length > 0
                      }"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4 text-gray-600">
                        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                        <circle cx="12" cy="10" r="3" />
                      </svg>
                      <span class="sr-only">Locate sample path</span>
                    </button>
                  </div>
                </td>

                <td class="px-1 py-2.5">
                  <VueToggles
                    checkedBg="#1E660B"
                    v-model="sample_path.show"
                    :width="50"
                    @click="setSamplePath(sample_path)"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div v-if="formStage === 3 || formStage === 4">
      <form class="overflow-hidden h-full" @submit.prevent="store">
        <div class="w-full relative">
          <div
            class="h-full w-full bg-white bg-opacity-75 absolute"
            v-if="showFormOverlay"
          ></div>
          <div
            class="p-2 lg:mx-4 lg:w-1/2"
            v-if="
              tab != 'zones' &&
              formStage === 4
            "
          >
            <label class="block text-sm font-medium text-gray-700" for="name">
              Farm
            </label>

            <select
              class="rounded w-full border-gray-300 text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-0 focus:placeholder-gray-400 sm:text-sm"
              v-model="fields.farm"
              required
            >
              <option selected>Select farm</option>
              <option
                v-for="(farm, index) in farms"
                v-bind:key="index"
                :value="farm.farm"
              >
                {{ farm.farm_name }}
              </option>
            </select>

            <div class="text-red-600" v-if="fields.errors && fields.errors.farm">
              {{ fields.errors.farm[0] }}
            </div>
          </div>

          <div class="p-2 lg:mx-4 lg:w-1/2" v-if="tab != 'zones'">
            <label class="block text-sm font-medium text-gray-700" for="name">
              Name
            </label>
            <input
              class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
              id="name"
              type="text"
              autocomplete="name"
              v-model="fields.name"
            />

            <div class="text-red-600" v-if="fields.errors && fields.errors.name">
              {{ fields.errors.name[0] }}
            </div>
          </div>

          <div class="p-2 lg:mx-4 lg:w-1/2">
            <label
              class="block text-sm font-medium text-gray-700"
              for="name"
              v-if="tab == 'parcels'"
            >
              Parcel No.
            </label>

            <label
              class="block text-sm font-medium text-gray-700"
              for="name"
              v-else
            >
              Zone No
            </label>


            <div class="flex gap-2">
              <input
                class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                :class="{
                  'border-red-500': parcelNumberValidation.hasError,
                  'border-yellow-500': parcelNumberValidation.hasWarning
                }"
                id="fieldNo"
                type="text"
                autocomplete="off"
                v-model="fields.fieldNo"
                @input="onParcelNumberChange"
                placeholder="Parcel No (e.g. 1, 2, 3)"
              />
              <select
                class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-20 shadow-sm sm:text-sm border-gray-300 rounded-md"
                :class="{
                  'border-red-500': parcelNumberValidation.hasError,
                  'border-yellow-500': parcelNumberValidation.hasWarning
                }"
                id="fieldNoSuffix"
                v-model="fields.field_no_suffix"
                @change="onParcelNumberChange"
              >
                <option value="">--</option>
                <option v-for="letter in suffixOptions" :key="letter" :value="letter">
                  {{ letter }}
                </option>
              </select>
            </div>

            <div class="text-red-600" v-if="fields.errors && fields.errors.fieldNo">
              {{ fields.errors.fieldNo[0] }}
            </div>
            
            <!-- Real-time validation messages -->
            <div v-if="parcelNumberValidation.message" class="mt-1 text-sm">
              <div 
                v-if="parcelNumberValidation.type === 'error'" 
                class="text-red-600 flex items-center"
              >
                <svg class="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd"></path>
                </svg>
                {{ parcelNumberValidation.message }}
              </div>
              <div 
                v-if="parcelNumberValidation.type === 'warning'" 
                class="text-yellow-600 flex items-center"
              >
                <svg class="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"></path>
                </svg>
                {{ parcelNumberValidation.message }}
              </div>
            </div>
            
            <!-- Loading indicator -->
            <div v-if="parcelNumberValidation.isValidating" class="mt-1 text-sm text-gray-500 flex items-center">
              <svg class="animate-spin -ml-1 mr-2 h-4 w-4 text-gray-500" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              Checking...
            </div>
          </div>

          <div class="p-2 lg:mx-4 lg:w-1/2">
            <label class="block text-sm font-medium text-gray-700" for="nmp_plot_id">
              NMP Plot ID
            </label>

            <input
              class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
              id="nmp_plot_id"
              type="text"
              placeholder="Optional - from NMP Online system"
              v-model="fields.nmp_plot_id"
            />

            <div class="text-red-600" v-if="fields.errors && fields.errors.nmp_plot_id">
              {{ fields.errors.nmp_plot_id[0] }}
            </div>
          </div>

          <div class="p-2 lg:mx-4 lg:w-1/2">
            <label class="block text-sm font-medium text-gray-700" for="name">
              Crop
            </label>

            <select
              class="rounded w-full border-gray-300 text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-0 focus:placeholder-gray-400 sm:text-sm"
              v-model="fields.crop"
            >
              <option
                v-for="(crop, index) in crops"
                v-bind:key="index"
                :value="crop.value"
              >
                {{ crop.text }}
              </option>
            </select>

            <div class="text-red-600" v-if="fields.errors && fields.errors.crop">
              {{ fields.errors.crop[0] }}
            </div>
          </div>

          <div class="p-2 lg:mx-4 lg:w-1/2">
            <label class="block text-sm font-medium text-gray-700" for="name">
              Soil Type
            </label>

            <select
              class="rounded w-full border-gray-300 text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-0 focus:placeholder-gray-400 sm:text-sm"
              v-model="fields.soilType"
            >
              <option
                v-for="(soil, index) in soilType"
                v-bind:key="index"
                :value="soil.value"
              >
                {{ soil.text }}
              </option>
            </select>

            <div class="text-red-600" v-if="fields.errors && fields.errors.soilType">
              {{ fields.errors.soilType[0] }}
            </div>
          </div>

          <div
            class="p-2 lg:mx-4 lg:w-1/2 flex gap-x-4"
            v-if="tab == 'parcels'"
          >
            <input
              type="checkbox"
              v-model="fields.createSampleZone"
              id="checkZone"
            />
            <label
              class="block text-sm font-medium text-gray-700"
              for="checkZone"
            >
              Create sample zone
            </label>
          </div>
        </div>

        <div class="p-2 lg:mx-4">
          <div
            class="text-red-600 mb-3"
            v-if="(fields.errors && fields.errors.boundaries) || (fields.errors && fields.errors.boundaries_xy)"
          >
            Draw the field boundary on the map before press save.
          </div>
          <div class="flex gap-x-5">
            <button type="submit" @click="cancelParcelForm" class="btn-secondary">
              Cancel
            </button>
            <button 
              type="submit" 
              @click="storeForm" 
              :disabled="!canSave"
              :class="[
                'btn-primary',
                {
                  'opacity-50 cursor-not-allowed': !canSave,
                  'hover:bg-blue-700': canSave
                }
              ]"
            >
              Save
            </button>
            <button 
              type="submit" 
              @click="storeFormAndAddAnother" 
              :disabled="!canSave"
              :class="[
                'btn-primary bg-green-600',
                {
                  'opacity-50 cursor-not-allowed': !canSave,
                  'hover:bg-green-700': canSave
                }
              ]"
            >
              Save and Add Another
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { useForm } from "@inertiajs/inertia-vue3";
import axios from "axios";
import LocationMark from "@/Components/Icons/LocationMark.vue";
import EditIcon from "@/Components/Icons/EditIcon.vue";
import { VueToggles } from "vue-toggles";
import { useToast } from "vue-toastification";
import _ from "lodash";

export default {
  components: {
    LocationMark,
    EditIcon,
    VueToggles,
  },
  props: {
    farmer: Object,
    farms: Array,
    farmer_zones: Array,
    step: Number,
    farmHashId: String,
    farmId: Number,
    currentFarm: Object,
    action: String,
    showSamplePath: [String, Boolean, Object],
    initialFarmName: String,
  },
  data() {
    return {
      form: useForm({
        name: "",
        farmer: {},
        farmLocation: {
          location: "",
          location_xy: "",
        },
        action: "",
        edit: false,
      }),
      formStage: 1,
      allowSubmit: false,
      pickLocation: false,
      loading: false,
      tab: "parcels",
      farm: {},
      errors: {},
      parcels: [],
      lastFieldNo: {},
      zones: {},
      selected_farmer_zones: [],
      sample_paths: [],
      fields: {
        name: "",
        fieldNo: "",
        field_no_suffix: "",
        nmp_plot_id: "",
        crop: "grassland",
        soilType: "mineral_soil",
        createSampleZone: true,
        boundaries: null,
        boundaries_xy: null,
        acre: 0,
        hectare: 0,
        submitted: false,
        action: null,
      },
      suffixOptions: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"],
      samplePathsToShow: null,
      toast: null,
      showFormOverlay: false,
      allowAutoZoom: true, // Flag to control automatic zooming
      saveAndAddAnother: false, // Flag to indicate if user wants to add another parcel
      // Parcel number validation state
      parcelNumberValidation: {
        isValidating: false,
        hasError: false,
        hasWarning: false,
        message: null,
        type: null
      }
    };
  },

  async mounted() {
    this.farm = this.currentFarm || {}; // set the current farm with fallback
    this.formStage = this.step || 1; // set the current step with fallback
    this.form.action = this.action || ""; // set the current action with fallback
    this.form.farmer = this.farmer || {}; // set the current farmer with fallback
    this.selected_farmer_zones = this.farmer_zones || []; //setting all farmer zones with fallback
    this.toast = useToast();
    
    //formStage 1 is for creating a new farm
    if (this.formStage == 1) {
      // enable adding point on map
      if (this.form.action == "create-farm") {
        this.addFarmPoint("farm-location");
      }
      
      // If this is a direct edit from Unified Parcels View, automatically call EditFarm()
      if (this.action == "edit-farm-direct") {
        this.$nextTick(() => {
          this.EditFarm();
        });
      }
    }

    //formStage 3 is for creating a new parcel or zone
    //formStage 2 is for listing both parcels and zones
    if (this.formStage == 2) {
      await this.loadParcelAndZone(this.farm.hashid);
      
      // If this is a parcel edit from Unified Parcels View, find and edit the parcel
      if (this.action == "edit-parcel-from-unified" && this.$parent.targetParcel) {
        this.$nextTick(() => {
          // Find the parcel in the loaded parcels list
          const targetParcel = this.parcels.find(p => 
            p.item_id === this.$parent.targetParcel.item_id || 
            p.hashid === this.$parent.targetParcel.hashid
          );
          
          if (targetParcel) {
            // Call Edit with the properly loaded parcel data (same as normal Step 2 flow)
            this.Edit(targetParcel);
          }
        });
      }

      // Only zoom on initial load, not when returning from editing
      // zoom the map to the parcels location once the parcel is loaded
      if (this.parcels && this.allowAutoZoom) {
        //emit and event to zoom to a particular location
        this.$emitter.emit(
          "zoomTolocationEmitted",
          this.parcels.map((parcel) => parcel.boundaries)
        );
      }
    }

    // Handle direct parcel creation (skip step 2)
    if (this.formStage == 3 && this.action == "create-parcels-direct") {
      // Load parcel and zone data first, then set up for parcel creation
      await this.loadParcelAndZone(this.farm.hashid);
      
      // Set up for parcel creation
      this.tab = 'parcels';
      this.form.action = "create-parcels-or-zones"; // Set the expected form action for map interaction
      this.initializeParcelCreation(); // Initialize clean form
      
      // Display existing parcels on the map for context
      await this.loadParcelandZoneToShowOnMap();
      
      // Enable map interaction for parcel drawing
      this.addFarmPoint("parcel-and-zone");
    }

    // listen for map interaction, if no interaction get event to save the old data
    this.$emitter.on("argicsMapLocationUseOldDetails", (payload) => {
      if (payload.status == true) {
        this.allowSubmit = true;
      }
    });

    // listen for the location data from the map interaction and set allowSubmit to true
    this.$emitter.on("argicsMapLocation", (payload) => {
      this.$root.showMapOnMobile = false;
      this.showFormOverlay = false;
      switch (payload.action) {
        case "farm-location":
          this.form.farmLocation.location = payload.identifier;
          this.form.farmLocation.location_xy = payload.identifier_xy;

          break;

        case "parcel-and-zone":
        case "edit-parcel-and-zone":
          this.fields.boundaries = payload.identifier;
          this.fields.boundaries_xy = payload.identifier_xy;
          this.fields.acre = payload.acre;
          this.fields.hectare = payload.hectare;
          break;

        default:
          break;
      }

      this.allowSubmit = true;
    });

    // Listen for create new parcel event from unified parcels view
    this.$emitter.on("create-new-parcel", () => {
      // Ensure we're on the parcels tab and then create new parcel
      this.tab = 'parcels';
      this.createNew('parcels');
    });


  },

  computed: {
    crops() {
      return [
        { value: "grassland", text: "Grassland" },
        { value: "arable", text: "Arable" },
        { value: "other", text: "Other" },
      ];
    },
    soilType() {
      return [
        { value: "mineral_soil", text: "Mineral Soil" },
        { value: "peat", text: "Peat" },
      ];
    },
    canSave() {
      // Can save if there are no validation errors (warnings are OK)
      return !this.parcelNumberValidation.hasError;
    },
  },
  beforeUnmount() {
    // Set a flag to indicate component is being destroyed
    this._isDestroying = true;
    
    // Clean up any pending operations
    if (this.parcelNumberValidation) {
      this.parcelNumberValidation.isValidating = false;
    }
  },
  watch: {
    "form.farmLocation"(newValue) {
      if (newValue != {}) {
        this.pickLocation = true;
      }
    },
    allowSubmit(newValue) {
      if (newValue && this.fields.submitted) {
        this.submitForm();
      }
    },
    "fields.submitted"(newValue) {
      if (newValue && this.allowSubmit) {
        this.submitForm();
      }
    },
    async formStage(newValue) {
      switch (newValue) {
        case 1:
        case 3:
          const action = newValue == 1 ? "farm-location" : "parcel-and-zone";
          if ((newValue == 1 && this.form.action == "create-farm") || newValue == 3) {
            this.addFarmPoint(action);
          }
          break;
        case 2:
          this.resetForm();
          let vm = this;
          let farm;
          try {
            vm.$emitter.emit("cancelFarmInteraction");
          } catch (error) {
            console.log(error);
            console.log("Clearing all Map interaction");
          }
          farm = this.farm.hashid || this.farmHashId;
          // Disable auto-zoom when returning from editing
          vm.allowAutoZoom = false;
          await vm.loadParcelAndZone(farm);
          // Ensure zoom is disabled when returning to parcel list view
          if (vm.$root.farmer) {
            vm.$root.farmer.zoom = false;
          }
          await vm.loadParcelandZoneToShowOnMap();
          break;
        case 4:
          // Editing mode - the editing graphics are set via this.$root.fields in the Edit() method
          // No additional action needed here, just prevent interference from other watchers
          break;
      }
    },
    tab(newValue) {
      // Don't handle tab changes when in editing mode
      if (this.formStage === 4) {
        return;
      }
      this.handleTabChange(newValue);
    },
    // Watch for when backend data loads and update field number if we're in creation mode
    lastFieldNo: {
      handler(newValue) {
        // Only update if we're in creation mode (not editing) and the field number looks like a fallback value
        if (this.formStage === 3 && this.fields.action === "creating" && newValue && newValue.percel !== undefined) {
          const currentFieldNo = parseInt(this.fields.fieldNo) || 0;
          const correctFieldNo = parseInt(newValue.percel) + 1;
          
          // If the current field number seems to be a fallback (much lower than the correct one),
          // update it to the correct farmer-wide value
          if (currentFieldNo < correctFieldNo) {
            this.fields.fieldNo = String(correctFieldNo);
            // Re-trigger validation with the updated field number
            this.$nextTick(() => {
              this.validateParcelNumber();
            });
          }
        }
      },
      deep: true
    },
  },
  methods: {
    handleTabChange(newValue) {
      // Don't update map data when we're in editing mode (formStage 4)
      // This prevents overriding the editing graphics
      if (this.formStage === 4) {

        return;
      }
      
      let vm = this;
      let farm = this.farm.hashid || this.farmHashId;
      if (newValue == "zones") {
        axios
          .post(route("app.farmer.map.view", this.farmer.id), {
            view: "zones",
          })
          .then(function (response) {
            response.data.hide_farm_location = false;
            response.data.active_farm = farm;
            vm.$root.farmer = response.data;
          });
        this.showSamplePaths();
      } else if (newValue == "parcels") {
        axios
          .post(route("app.farmer.map.view", this.farmer.id), {
            view: "parcels",
          })
          .then(function (response) {
            response.data.hide_farm_location = false;
            response.data.active_farm = farm;
            vm.$root.farmer = response.data;
          });
        this.showSamplePaths();
      } else if (newValue == "sample_paths") {
        axios
          .post(route("app.farmer.map.view", this.farmer.id), {
            view: "zones",
          })
          .then(function (response) {
            response.data.hide_farm_location = false;
            response.data.active_farm = farm;
            vm.$root.farmer = response.data;
          });
        // this.$root.paths = [];
      }
    },
    setSamplePath(path) {
      this.samplePathsToShow = path;
      this.showSamplePaths();
    },
    showSamplePaths() {
      if (this.samplePathsToShow?.sample_paths.length > 0) {
        const arryOfPaths = this.samplePathsToShow.sample_paths;

        this.$root.paths.samples = arryOfPaths;
        this.$root.paths.zoom = true; // this is to enable zoom for the selected paths
      }
    },
    
    locateSamplePath(samplePath) {
      if (!samplePath || !samplePath.sample_paths || samplePath.sample_paths.length === 0) {
        if (this.$toast) {
          this.$toast.error('No location data available for this sample path.');
        }
        return;
      }
      
      // Set the sample path data and enable zoom
      this.$root.paths.samples = samplePath.sample_paths;
      this.$root.paths.zoom = true;
      
      // Show success message
      if (this.$toast) {
        this.$toast.success(`Zooming to sample path: ${samplePath.task_id}`);
      }
      
      // Disable zoom after animation completes
      setTimeout(() => {
        if (this.$root.paths) {
          this.$root.paths.zoom = false;
        }
      }, 1200);
    },
    backToFarms() {
      this.$emit("changeStage", "farms");
      //this.$emit("changeStage", "reload");
      this.formStage = 1;
    },

    // To clear any interactio with the map and reset the form
    closeCreate(action) {
      this.resetForm();
      try {
        this.$emitter.emit("cancelFarmInteraction");
      } catch {
        // Error clearing map interaction
      } finally {
        this.$emit("close", action); // close create farm tab
      }
    },

    // loading parcel and zone map data
    async loadParcelandZoneToShowOnMap() {
      // Don't update map data when we're in editing mode (formStage 4)
      // This prevents overriding the editing graphics
      if (this.formStage === 4) {

        return;
      }
      
      const farm = this.farm.hashid || this.farmHashId;
      const vm = this;

      try {
        const response = await axios.post(route("app.farmer.map.view", this.farmer.id), {
          view: this.tab,
        });

        // Check if component is still mounted and not being destroyed before updating data
        if (vm.$el && !vm._isDestroying && response.data) {
          response.data.hide_farm_location = false; // this determin when to show location marker
          response.data.active_farm = farm;
          response.data.allowToLocationOnMap = true;
          response.data.zoom = false; // disable zooming

          vm.$root.farmer = response.data;
        }
      } catch (error) {
        // Silently handle errors to prevent console spam
      }
    },
    async Edit(data) {
      // Handle different ID formats: unified view uses item_id, regular flow uses id
      this.fields.id = data.id || data.item_id;
      // this.fields.zone_id = data.zone_id
      this.fields.farm = data.farm_id;
      this.fields.name = data.name;
      this.fields.fieldNo = String(data.field_no);
      this.fields.field_no_suffix = data.field_no_suffix || "";
      this.fields.nmp_plot_id = data.nmp_plot_id || "";
      
      // Safely find crop value or default to grassland
      const foundCrop = this.crops.find((crop) => crop.text === data.crop);
      this.fields.crop = foundCrop ? foundCrop.value : "grassland";
      
      // Safely find soil type value or default to mineral_soil
      const foundSoilType = this.soilType.find((soil) => soil.text === data.soil_type);
      this.fields.soilType = foundSoilType ? foundSoilType.value : "mineral_soil";
      this.fields.boundaries = data.boundaries;
      this.fields.boundaries_xy = data.boundaries_xy;

      this.fields.acre = data.acre || 0;
      this.farm.id = data.farm_id;

      // Trigger validation for the loaded parcel number
      this.$nextTick(() => {
        this.validateParcelNumber();
      });

      if (data.allowAction) {
        const response = await this.$swal.fire({
          title: "Warning",
          text: "There are results assosiated with this parcel, do you want to edit anyway?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Edit",
        });

        if (!response.isConfirmed) {
          return null;
        }
      }

      //change view to editing farm location
      const editingData = {
        sample_id: data.field_no,
        hashid: data.hashid,
        paths_xy: data.boundaries_xy,
        type: "edit",
      };
      
      this.$root.fields = [editingData];
      // Debug: Setting editing mode
      console.log('Setting editing mode with fields:', this.$root.fields);
      
      this.formStage = 4;
      this.fields.action = "updating";
      
      // Ensure editing graphics persist after any reactive updates
      this.$nextTick(() => {
        if (!this.$root.fields || this.$root.fields.length === 0 || this.$root.fields[0].type !== "edit") {
          // Debug: Restoring editing graphics that were cleared
        console.log('Restoring editing graphics that were cleared');
          this.$root.fields = [editingData];
        }
      });
    },
    async Delete(item) {
      let vm = this;
      const response = await this.$swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });
      if (!response.isConfirmed) {
        return;
      }

      axios
        .delete(
          route("app.farm.widget.delete", {
            action: vm.tab,
            hashid: item.hashid,
          })
        )
        .then(async function (response) {
          await vm.loadParcelAndZone(vm.farm.hashid);
          await vm.loadParcelandZoneToShowOnMap();
          
          // If we came from unified parcels view, refresh data and return
          if (vm.$parent.cameFromUnifiedParcelsView) {
            vm.$emit("changeStage", "farms-refresh");
          } else {
            vm.formStage = 2;
          }
          vm.$swal.fire("Deleted!", "Parcel has been deleted.", "success");
        });
    },
    //saving farm details
    async saveFarm() {
      //send a request to store for backend
      let vm = this;
      let allowSave = false;
      let result;
      if (this.form.farmLocation.location.length == 0) {
        if (this.initialFarmName && this.$parent.pendingImportData) {
          // For import actions, location is mandatory
          this.$swal.fire({
            title: "Location Required",
            text: "You must set a farm location before importing parcels. Click on the map to set the location.",
            icon: "warning",
            confirmButtonText: "OK"
          });
          this.$emitter.emit("addFarmPoint", {
            action: "farm-location",
            type: this.form.action,
          });
          return; // Don't proceed with save
        } else {
          // For regular farm creation, allow saving without location with confirmation
          result = await this.$swal.fire({
            title: "Are you sure?",
            text: "Confirm to create a farm without setting a location",
            icon: "warning",
            showCancelButton: true,
            cancelButtonColor: "#d33",
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Yes, create it!",
          });
        }
      } else {
        allowSave = true;
      }

      if (result && !result.isConfirmed) {
        this.$emitter.emit("addFarmPoint", {
          action: "farm-location",
          type: this.form.action,
        });
      }

      if ((result && result.isConfirmed) || allowSave) {

        
        axios
          .post(route("app.farm.store"), this.form)
          .then(function (response) {
            vm.farm = response.data;
            
            // Store edit state before clearing it
            const wasEditing = vm.form.edit;
            vm.form.edit = false;
            
            // Check if this is for an import (parent has pendingImportData)
            if (vm.$parent.pendingImportData) {
              // For imports, emit reload with the created farm data to trigger import processing
              vm.$emit("changeStage", "reload", { createdFarm: response.data });
            } else if (wasEditing) {
              // For farm editing, refresh data and return to unified view
              vm.$emit("changeStage", "farms-refresh");
            } else {
              // For farm creation, emit close event and let parent handle navigation
              vm.$emit("close", "farm-created");
            }
          })
          .catch((error) => {
            if (error.response?.status === 403) {
              vm.toast.error("You don't have permission to create farms. Please contact your administrator.");
            } else if (error.response?.data?.errors) {
              vm.errors = error.response.data.errors;
            } else {
              vm.toast.error("An error occurred while saving the farm.");
            }
          });
      }
    },

    //check if boundaries is draw for the percel or zone
    storeForm() {
      // Prevent submission if there are validation errors (same-farm conflicts)
      if (!this.canSave) {
        return;
      }
      
      this.saveAndAddAnother = false;
      if (this.fields.boundaries == null) {
        this.fields.errors = {
          boundaries: ["Draw the field boundary on the map before press save."],
        };
        return;
      }

      // Only disable paths zoom if we're not showing sample paths for reference
      if (!this.showSamplePath) {
        this.$root.paths.zoom = false; // set this to disable zoom for sample paths
      }

      // there is a value watch that check if the submitted is true and submit the form
      this.fields.submitted = true;
      this.$emitter.emit("completeAllEditing");
    },

    storeFormAndAddAnother() {
      // Prevent submission if there are validation errors (same-farm conflicts)
      if (!this.canSave) {
        return;
      }
      
      this.saveAndAddAnother = true;
      if (this.fields.boundaries == null) {
        this.fields.errors = {
          boundaries: ["Draw the field boundary on the map before press save."],
        };
        return;
      }

      // Only disable paths zoom if we're not showing sample paths for reference
      if (!this.showSamplePath) {
        this.$root.paths.zoom = false; // set this to disable zoom for sample paths
      }

      // there is a value watch that check if the submitted is true and submit the form
      this.fields.submitted = true;
      this.$emitter.emit("completeAllEditing");
    },

    submitForm() {
      this.fields.submitted = false;
      let vm = this;
      let newFarmId;

      if (!this.fields.farm) {
        newFarmId = this.farm.id ? this.farm.id : this.farmId;
      } else {
        newFarmId = this.fields.farm;
      }

      // this save the record if is parcel or zones then load back the fresh record, just to manage state
      axios
        .post(route("app.farm.storeFarmParcelsAndZones", this.farm.hashid), {
          ...this.fields,
          farmer: this.farmer,
          type: this.tab,
          farm: newFarmId,
        })
        .then(function (response) {
          vm.parcels = response.data.parcels;
          vm.zones = response.data.sample_zones;
          vm.selected_farmer_zones = response.data.farmer_zones;
          vm.resetForm();
          vm.lastFieldNo = {
            percel: response.data.last_field_no_parcel,
            zone: response.data.last_field_no_zone,
          };
          vm.allowSubmit = false;
          
          // Handle "Save and Add Another" workflow
          if (vm.saveAndAddAnother) {
            vm.toast.success(`${vm.tab} saved successfully! Add another ${vm.tab}.`);
            vm.saveAndAddAnother = false; // Reset flag
            vm.formStage = 3; // Stay in parcel/zone create mode
            // Auto-increment field number for convenience
            if (vm.tab === 'parcels' && vm.lastFieldNo.percel) {
              vm.fields.fieldNo = (parseInt(vm.lastFieldNo.percel) + 1).toString();
            } else if (vm.tab === 'zones' && vm.lastFieldNo.zone) {
              vm.fields.fieldNo = (parseInt(vm.lastFieldNo.zone) + 1).toString();
            }
            
            // Prepare for next parcel/zone creation
            vm.fields.action = "creating";
            
            // Update map view to show all parcels/zones for context, then enable drawing
            vm.$nextTick(async () => {
              // First refresh the map view to show all existing parcels/zones
              await vm.loadParcelandZoneToShowOnMap();
              
              // Then enable map interaction for drawing the next boundary
              vm.addFarmPoint("parcel-and-zone");
            });
            
            return;
          }
          
          // If we came from unified parcels view, refresh data and return
          if (vm.$parent.cameFromUnifiedParcelsView) {
            vm.$emit("changeStage", "farms-refresh");
          } else {
            // Copy the exact same cleanup approach as "Save and Add Another"
            vm.$nextTick(async () => {
              // First refresh the map view to show all existing parcels/zones
              await vm.loadParcelandZoneToShowOnMap();
              
              // Then enable map interaction (this clears temporary graphics)
              vm.addFarmPoint("parcel-and-zone");
              
              // Immediately cancel the interaction and go to farm overview
              vm.$nextTick(() => {
                vm.$emitter.emit("cancelFarmInteraction");
                vm.formStage = 2;
              });
            });
          }
        })
        .catch((error) => {
          if (error.response?.status === 403) {
            vm.toast.error("You don't have permission to create parcels/zones. Please contact your administrator.");
          } else if (error.response?.data?.errors) {
            vm.fields.errors = error.response.data.errors;
          } else {
            vm.toast.error("An error occurred while saving the parcel/zone.");
          }
        });

      this.allowSubmit = false;
    },
    async loadParcelAndZone(farmHashId) {
      this.loading = true;

      try {
        const response = await axios.get(
          route("app.farm.parcels-zone", { farm: farmHashId })
        );

        if (!response.data) {
          return;
        }

        // Check if component is still mounted and not being destroyed before updating data
        if (this.$el && !this._isDestroying) {
          this.parcels = response.data.parcels || [];
          this.zones = response.data.sample_zones || [];
          this.sample_paths = response.data.sample_paths || [];
          this.lastFieldNo = {
            percel: response.data.last_field_no_parcel || 0,
            zone: response.data.last_field_no_zone || 0,
          };
        }
      } catch (error) {
        // Silently handle errors to prevent console spam
      } finally {
        if (this.$el) {
          this.loading = false;
        }
      }

      // if there is a sample path sent, turn it on
      if (this.showSamplePath && this.sample_paths.length) {
        this.sample_paths = this.sample_paths.map((sample_path) => {
          if (sample_path.task_id == this.showSamplePath) {
            sample_path.show = true;
          }
          return sample_path;
        });

        this.samplePathsToShow = this.sample_paths.find(
          (sample_path) => sample_path.task_id == this.showSamplePath
        );
        this.$root.paths.samples = this.samplePathsToShow?.sample_paths || [];
      }
      this.loading = false;
    },
    getToastMessage(action) {
      if (action == "farm-location") {
        return "Click on the map to set the farm location.";
      } else {
        return "Draw the boundry for the field.";
      }
    },
    addFarmPoint(action) {
      //hide side menu on mobile view
      this.$root.showMapOnMobile = true;
      this.showFormOverlay = true;
      this.toast.info(this.getToastMessage(action));

      this.$emitter.emit("addFarmPoint", {
        action,
        type: this.form.action,
      });
    },

    resetForm() {
      this.fields = {
        name: "",
        fieldNo: "",
        field_no_suffix: "",
        nmp_plot_id: "",
        crop: "grassland",
        soilType: "mineral_soil",
        createSampleZone: true,
        boundaries: null,
        boundaries_xy: null,
        acre: 0,
        hectare: 0,
        submitted: false,
        action: null,
      };
      
      // Clear any editing graphics from the map only if we're not in editing mode
      if (this.$root.fields && this.formStage !== 4) {
        this.$root.fields = [];
      }

      // Reset validation state
      this.parcelNumberValidation = {
        isValidating: false,
        hasError: false,
        hasWarning: false,
        message: null,
        type: null
      };
    },
    
    initializeParcelCreation() {
      // Set up form for new parcel creation
      this.fields = {
        action: "creating",
        name: "",
        fieldNo: this.getNextFieldNumber(),
        field_no_suffix: "",
        nmp_plot_id: "",
        crop: "grassland",
        soilType: "mineral_soil",
        createSampleZone: true,
        boundaries: null,
        boundaries_xy: null,
        acre: 0,
        hectare: 0,
        submitted: false,
      };
      
      // Clear any editing graphics from the map
      if (this.$root.fields) {
        this.$root.fields = [];
      }

      // Reset validation state
      this.parcelNumberValidation = {
        isValidating: false,
        hasError: false,
        hasWarning: false,
        message: null,
        type: null
      };

      // Trigger validation for the auto-generated field number
      this.$nextTick(() => {
        this.validateParcelNumber();
      });
    },

    getNextFieldNumber() {
      // Use the farmer-wide field number from backend if available
      // This ensures parcels are numbered sequentially across ALL farms for this farmer
      if (this.lastFieldNo && this.lastFieldNo.percel !== undefined) {
        return String(parseInt(this.lastFieldNo.percel) + 1);
      }
      
      // Fallback: If backend data not available yet, calculate from current farm parcels
      // Note: This is only a temporary value until backend data loads and the watcher updates it
      if (this.parcels && this.parcels.length > 0) {
        const maxFieldNo = Math.max(...this.parcels.map(p => parseInt(p.field_no) || 0));
        return String(maxFieldNo + 1);
      }
      return "1";
    },
    EditFarm() {
      // Use the farmId prop which should contain the actual database ID (like the regular farmEdit does)
      const farmId = this.farmId || this.farm.farm;
      
      this.form.id = farmId;
      this.form.name = this.farm.farm_name;
      this.form.farmer = this.farmer;
      this.form.edit = true;
      this.form.farmLocation = {
        location: this.farm.location,
        location_xy: this.farm.location_xy,
      };
      this.form.action = "update-farm";
      this.formStage = 1;
      this.allowSubmit = false;
    },
    createNew(type) {
      this.formStage = 3;
      this.form.action = "create-parcels-or-zones";
      this.fields.action = "creating";
      type == "parcels"
        ? (this.fields.fieldNo = String(parseInt(this.lastFieldNo.percel) + 1))
        : (this.fields.fieldNo = String(parseInt(this.lastFieldNo.zone) + 1));
    },
    
    cancelParcelForm() {
      // Clear any editing graphics from the map
      this.resetForm();
      
      // Cancel any active map editing
      try {
        this.$emitter.emit("cancelFarmInteraction");
      } catch (error) {
        // Error cancelling map interaction
      }
      
      // If we came from unified parcels view, return there (no reload needed for cancel)
      if (this.$parent.cameFromUnifiedParcelsView) {
        // Emit farms stage (not farms-refresh) so parent can detect and selectively reload features
        this.$emit("changeStage", "farms");
      } else {
        this.formStage = 2;
      }
    },
    
    // Real-time parcel number validation
    onParcelNumberChange: _.debounce(function() {
      this.validateParcelNumber();
    }, 500),

    async validateParcelNumber() {
      // Reset validation state
      this.parcelNumberValidation = {
        isValidating: false,
        hasError: false,
        hasWarning: false,
        message: null,
        type: null
      };

      // Skip validation if no field number is entered
      if (!this.fields.fieldNo || !this.fields.fieldNo.trim()) {
        return;
      }

      // Skip validation if we don't have the required data
      const farmId = this.farmId || this.farm?.id || this.farm?.farm;
      if (!this.farmer?.farmer_id || !farmId) {
        return;
      }

      this.parcelNumberValidation.isValidating = true;

      try {
        const response = await axios.post(route('app.farm.check-parcel-number'), {
          type: this.tab, // 'parcels' or 'zones'
          farmer_id: this.farmer.farmer_id,
          farm_id: farmId,
          field_no: this.fields.fieldNo.trim(),
          field_no_suffix: this.fields.field_no_suffix || null,
          parcel_id: this.fields.id || null // For updates
        });

        const data = response.data;

        if (data.current_farm_conflict) {
          this.parcelNumberValidation.hasError = true;
          this.parcelNumberValidation.type = 'error';
          this.parcelNumberValidation.message = data.message;
        } else if (data.other_farms_conflicts.length > 0) {
          this.parcelNumberValidation.hasWarning = true;
          this.parcelNumberValidation.type = 'warning';
          this.parcelNumberValidation.message = data.message;
        }

      } catch (error) {
        // Don't show user error for validation failures
      } finally {
        this.parcelNumberValidation.isValidating = false;
      }
    },
  },
};
</script>
<style></style>
